import React from "react";
import CaseManagementPage from "./CaseManagementPage";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { MinerPageContextProvider } from "../minerstatusV2/context/MinerPageContextProvider";
import { SiteAndGroupTreeContextProvider } from "../minerstatusV2/context/SiteAndGroupTreeContext";

const CaseManagementPageWrapper = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      mutations: {
        // Default options for all mutations
        retry: 1, // Number of retry attempts
        onSuccess: (data) => {
          console.log("Mutation succeeded:", data);
        },
        onError: (error) => {
          console.error("Mutation failed:", error);
        },
      },
    },
  });
  return (
    <MinerPageContextProvider>
      <SiteAndGroupTreeContextProvider>
        <QueryClientProvider client={queryClient}>
          <CaseManagementPage />
        </QueryClientProvider>
      </SiteAndGroupTreeContextProvider>
    </MinerPageContextProvider>
  );
};

export default CaseManagementPageWrapper;
